import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Primary", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Secondary", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Tertiary", -1)
const _hoisted_4 = { class: "dark-background" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Secondary Dark", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Secondary button over dark background", -1)
const _hoisted_7 = { class: "blue-toggle-buttons" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Big Blue Buttons", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TODO"),
  /*#__PURE__*/_createTextVNode(": this should be a \"Journey Selector\" (recently added to Design System 2.0) and moved to \"Forms & Inputs\" ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "mt-4" }, "Just Text", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", { class: "mt-8" }, "Icon and Text", -1)
const _hoisted_12 = { class: "grouped-buttons" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Grouped Buttons", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Adding a wrapper element with class "),
  /*#__PURE__*/_createElementVNode("code", null, ".button-group"),
  /*#__PURE__*/_createTextVNode(" will make the buttons 50/50. When putting a "),
  /*#__PURE__*/_createElementVNode("code", null, ".primary"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("code", null, ".secondary"),
  /*#__PURE__*/_createTextVNode(" button next to each other, always put the "),
  /*#__PURE__*/_createElementVNode("code", null, ".secondary"),
  /*#__PURE__*/_createTextVNode(" button first ")
], -1)
const _hoisted_15 = { class: "button-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Maxiumum Limits", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " Buttons have a maximum width of 336px. Any text that does not fit on a single line within that limit should be clipped by an ellipsis. ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Loading States", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " This is an example of how to add a loading state to a button when clicked. This example just runs a timer function for 2 seconds. In a real-world application you could run a form handler or send an API request. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "style-guide--buttons" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        lg: "6",
        xxl: "5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_1,
            _createVNode(_component_v_btn, null, {
              default: _withCtx(() => [
                _createTextVNode("Primary")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, { disabled: "" }, {
              default: _withCtx(() => [
                _createTextVNode("Primary Disabled")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(_component_v_btn, { class: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode("Secondary")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "secondary",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Secondary Disabled")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_v_btn, { class: "tertiary" }, {
              default: _withCtx(() => [
                _createTextVNode("Tertiary")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "tertiary",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Disabled")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_component_v_btn, { class: "secondary-light" }, {
              default: _withCtx(() => [
                _createTextVNode("Secondary (Dark)")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "secondary-light",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Secondary (Dark) Disabled")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_v_btn, { class: "big-blue" }, {
              default: _withCtx(() => [
                _createTextVNode("By myself")
              ]),
              _: 1
            }),
            _hoisted_11,
            _createVNode(_component_v_btn, {
              class: "big-blue",
              "prepend-icon": "ep-icon-coapplicant",
              stacked: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("With co-applicant")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        lg: "6",
        xxl: "5",
        "offset-xxl": "2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_v_btn, { class: "secondary" }, {
                default: _withCtx(() => [
                  _createTextVNode("Secondary (Dark)")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, null, {
                default: _withCtx(() => [
                  _createTextVNode("Secondary (Dark) Disabled")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _hoisted_17,
            _createVNode(_component_v_btn, null, {
              default: _withCtx(() => [
                _createTextVNode("Primary with more words than fit in the button")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, { class: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode("Secondary with more words than fit in the button")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, { class: "tertiary" }, {
              default: _withCtx(() => [
                _createTextVNode("Tertiary with more words than fit in the button")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_v_btn, {
              loading: _ctx.loading.primary,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load('primary'))),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.load('primary')), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Click Me ")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_v_btn, {
              class: "secondary",
              loading: _ctx.loading.secondary,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.load('secondary'))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.load('secondary')), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Click Me ")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_v_btn, {
              class: "tertiary",
              loading: _ctx.loading.tertiary,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.load('tertiary'))),
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.load('tertiary')), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Click Me ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}